import React from "react";

// A failed load: what went wrong and a way to try again, so a single bad request is never a dead end.
export default function LoadFailed({ message, onRetry }) {
  return (
    <div className="Login-Error" role="alert"
         style={{ display: "flex", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
      <span>{message}</span>
      {onRetry && (
        <button type="button" onClick={onRetry}
                style={{ border: "none", background: "transparent", cursor: "pointer", padding: 0,
                         font: "inherit", fontWeight: 600, color: "var(--blue-600)", textDecoration: "underline" }}>
          Try again
        </button>
      )}
    </div>
  );
}
